module.exports = __webpack_public_path__ + "static/media/BitcoinBlack.dba435e0.png";